import * as OrderActions from './order.actions';
import { AusmitError } from "../../shared/interfaces";
import { CriteriaModel, EmptyCriteria } from 'src/app/shared/interfaces/CriteriaModel';

export interface State {
    requestProcessing: boolean;

    GetCustomerOrders: {
        response: any;
        criteria: CriteriaModel;
    };
    DeliveryStatus: {
        response: any;
    };
    CancelItemOrder: {
        response: any;
    };
    GetItemOrderId: {
        response: any;
    };
    GetCustomerItemDocketStatus: {
        response: any;
    };
    PostComment: {
        response: any;
    };
    OrderReview: {
        response: any;
        criteria: CriteriaModel;
    };
}


export const initialState: State = {
    requestProcessing: false,

    GetCustomerOrders: {
        response: null,
        criteria: EmptyCriteria,
    },
    DeliveryStatus: {
        response: null
    },
    CancelItemOrder: {
        response: null
    },
    GetItemOrderId: {
        response: null
    },
    GetCustomerItemDocketStatus: {
        response: null
    },
    PostComment: {
        response: null
    },
    OrderReview: {
        response: null,
        criteria: EmptyCriteria,
    },
};

/*Creating the reducer function*/
export function OrderReducer(
    state = initialState,
    action: OrderActions.Actions
): State {
    switch (action.type) {
        case OrderActions.ActionTypes.GetCustomerOrders: {
            return {
                ...state,
                requestProcessing: true,
                GetCustomerOrders: {
                    ...state.GetCustomerOrders,
                    criteria: action.payload,
                    response: null,
                }
            };
        }
        case OrderActions.ActionTypes.GetCustomerOrdersSuccess: {
            return {
                ...state,
                requestProcessing: false,
                GetCustomerOrders: {
                    ...state.GetCustomerOrders,
                    response: action.payload,
                }
            };
        }
        case OrderActions.ActionTypes.GetCustomerOrdersError: {
            return {
                ...state,
                requestProcessing: false,
                GetCustomerOrders: {
                    ...state.GetCustomerOrders,
                    response: null,
                }
            };
        }
        case OrderActions.ActionTypes.CheckDeliverystatus: {
            return {
                ...state,
                requestProcessing: true,
                DeliveryStatus: {
                    response: null
                }
            };
        }
        case OrderActions.ActionTypes.CheckDeliverystatusSuccess: {
            return {
                ...state,
                requestProcessing: false,
                DeliveryStatus: {
                    response: action.payload,
                }
            };
        }

        case OrderActions.ActionTypes.CheckDeliverystatusError: {
            return {
                ...state,
                requestProcessing: false,
                DeliveryStatus: {
                    response: null
                }
            };
        }
        case OrderActions.ActionTypes.GetItemOrderId: {
            return {
                ...state,
                requestProcessing: true,
                GetItemOrderId: {
                    ...state.GetItemOrderId,
                    response: null,
                }
            };
        }
        case OrderActions.ActionTypes.GetItemOrderIdSuccess: {
            return {
                ...state,
                requestProcessing: false,
                GetItemOrderId: {
                    ...state.GetItemOrderId,
                    response: action.payload,
                }
            };
        }
        case OrderActions.ActionTypes.GetItemOrderIdError: {
            return {
                ...state,
                requestProcessing: false,
                GetItemOrderId: {
                    ...state.GetItemOrderId,
                    response: null,
                }
            };
        }
        case OrderActions.ActionTypes.CancelItemOrder: {
            return {
                ...state,
                requestProcessing: true,
                CancelItemOrder: {
                    ...state.CancelItemOrder,
                    response: null,
                }
            };
        }
        case OrderActions.ActionTypes.CancelItemOrderSuccess: {
            return {
                ...state,
                requestProcessing: false,
                CancelItemOrder: {
                    ...state.CancelItemOrder,
                    response: action.payload,
                }
            };
        }
        case OrderActions.ActionTypes.CancelItemOrderError: {
            return {
                ...state,
                requestProcessing: false,
                CancelItemOrder: {
                    ...state.CancelItemOrder,
                    response: null,
                }
            };
        }

        case OrderActions.ActionTypes.GetCustomerItemDocketStatus: {
            return {
                ...state,
                requestProcessing: true,
                GetCustomerItemDocketStatus: {
                    ...state.GetCustomerItemDocketStatus,
                    response: null,
                }
            };
        }
        case OrderActions.ActionTypes.GetCustomerItemDocketStatusSuccess: {
            return {
                ...state,
                requestProcessing: false,
                GetCustomerItemDocketStatus: {
                    ...state.GetCustomerItemDocketStatus,
                    response: action.payload,
                }
            };
        }
        case OrderActions.ActionTypes.GetCustomerItemDocketStatusError: {
            return {
                ...state,
                requestProcessing: false,
                GetCustomerItemDocketStatus: {
                    ...state.GetCustomerItemDocketStatus,
                    response: null,
                }
            };
        }
        case OrderActions.ActionTypes.OrderPostComment: {
            return {
                ...state,
                requestProcessing: true,
                PostComment: {
                    response: null
                }
            };
        }
        case OrderActions.ActionTypes.OrderPostCommentSuccess: {
            return {
                ...state,
                requestProcessing: false,
                PostComment: {
                    response: action.payload
                }
            };
        }
        case OrderActions.ActionTypes.OrderPostCommentError: {
            return {
                ...state,
                requestProcessing: false,
                PostComment: {
                    response: null
                }
            };
        }
        case OrderActions.ActionTypes.OrderReview: {
            return {
                ...state,
                requestProcessing: true,
                OrderReview: {
                    ...state.OrderReview,
                    criteria: action.payload,
                    response: null,
                }
            };
        }
        case OrderActions.ActionTypes.OrderReviewSuccess: {
            return {
                ...state,
                requestProcessing: false,
                OrderReview: {
                    ...state.OrderReview,
                    response: action.payload,
                }
            };
        }
        case OrderActions.ActionTypes.OrderReviewError: {
            return {
                ...state,
                requestProcessing: false,
                OrderReview: {
                    ...state.OrderReview,
                    response: null,
                }
            };
        }
        default:
            return state;
    }
}
